import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInitializer } from './app/Services/app-initializer';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(moduleRef => {
  const appInitializer = moduleRef.injector.get(AppInitializer);
  return appInitializer.initialize();
}).catch(err => console.error(err));
